<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1007434" style="color: #82a339"><b>MARINATED MIXED OLIVES</b></p>
<p class="ext" id="d7e1007934"><b><i>This assortment of olives is an inviting addition to any antipasto tray. If you have an orange on hand, mix its peel with—or use instead of—the lemon peel.</i></b></p>
<p class="h4" id="d7e1009234" style="color: #496210"><b>Prep: 10 minutes plus standing and marinating <br/> Cook: 5 minutes</b></p>
<p class="ul" id="d7e1010034">¼ cup extra-virgin olive oil</p>
<p class="ul" id="d7e1010934">2 teaspoons fennel seeds, crushed</p>
<p class="ul" id="d7e1011234">4 small bay leaves</p>
<p class="ul" id="d7e1011534">2 pounds assorted Mediterranean olives, such as <br/> Niçoise, picholine, or Kalamata</p>
<p class="ul" id="d7e1012234">6 strips (3" by 1" each) lemon peel</p>
<p class="ul" id="d7e1012534">4 garlic cloves, crushed with side of chef’s knife</p>
<p class="pub" id="d7e1013034" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 1-quart saucepan, heat oil, fennel seeds, and bay leaves over medium heat until hot but not smoking. Remove saucepan from heat; let stand 10 minutes.</p>
<p class="pub" id="d7e1014334"><span style="color: #c15b49"><b>2.</b></span> In large bowl, combine olives, lemon peel, garlic, and oil mixture. Cover and refrigerate, stirring occasionally, at least 24 hours or up to several days to blend flavors. Store in refrigerator up to 1 month. Drain to serve. Makes about 6 cups.</p>
<p class="ntx" id="d7e1016634">Each ¼ cup: About 107 calories, 1g protein, 3g carbohydrate, 10g total fat (1g saturated), 0mg cholesterol, 680mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c18_r1.vue?4f24e844